import { Privilege } from "./privilege";

type Role = {
  name: string;
  description: string;
  privileges: Privilege[];
};

const role: Role = {
  description: "",
  name: "",
  privileges: [],
};

export type { Role };

export { role };
